export default __webpack_public_path__ + "static/media/notify.33d0768c.mp3";